import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const documentTypeFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.label_document_type'),
  type: 'in',
  options: {
    options: [
      { label: i18n.t('expenses_v2.list.filters.receipt'), value: 'receipt' },
      { label: i18n.t('expenses_v2.list.filters.invoice'), value: 'invoice' },
      { label: i18n.t('expenses_v2.list.filters.other'), value: 'other' },
    ],
  },
})
